import { render } from "./exchange-home.vue?vue&type=template&id=067e9c39&scoped=true&ts=true"
import script from "./exchange-home.vue?vue&type=script&lang=ts"
export * from "./exchange-home.vue?vue&type=script&lang=ts"

import "./exchange-home.vue?vue&type=style&index=0&id=067e9c39&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067e9c39"]])